// Inline copy of src/assets/images/job-site.svg with the main shape's fill
// substituted at module load. We generate three colored data-URI variants
// (default green, aging yellow, stale red) so the Google Maps Marker icon API
// can consume them as plain URLs without runtime CSS-filter trickery.

const BASE_SVG = `<?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 590 590" enable-background="new 0 0 590 590" xml:space="preserve">
<path fill="__FILL__" stroke="#000000" stroke-width="16" d="M473.5,180.3c0.9,31.8-7.4,59.9-20.4,86.7c-12.3,25.4-25.3,50.5-37.4,76.1c-14.5,30.6-29.4,61.3-44.5,91.7c-14.9,30.1-29.2,60.4-44,90.5c-9.2,18.9-18,37.9-27.2,56.8c-0.7,1.4-0.7,4-2.9,3.8c-2.1,0-2.4-2.4-3.1-4C277.6,548,261,514.1,244.5,480c-13.3-27.5-26.8-55.2-40.3-82.7c-15.4-31.8-31.3-63.3-46-95.3c-9.3-20.2-20.6-39.5-27.7-60.7c-5.2-15.6-8.3-31.3-9.3-47.9c-2.1-32.2,4.2-62.3,18.7-90.8c15.4-30.3,37.6-54.2,66.8-71.6c21.1-12.6,43.8-20.4,68.2-23.2c26.3-3.1,51.9-1.4,77,6.9c23.7,7.8,44.8,20.2,63.7,37c29.1,25.8,46.4,58.1,54.9,95.3C472.9,158.1,475.2,170.1,473.5,180.3z M297.5,86.3c-53.1-0.9-97.4,42.9-97.1,96.2c0.3,53.1,41,96.7,97.1,96.7c52.4,0,93.8-40.1,96.2-92.9C396.3,130.1,349,85.3,297.5,86.3z"/>
<path d="M297.8,86.3c51.6-1,98.8,43.8,96.2,100c-2.4,52.8-43.8,92.9-96.2,92.9c-55.9,0-96.7-43.6-97.1-96.7C200.4,129.2,244.7,85.4,297.8,86.3z"/>
</svg>`;

const tint = (fill: string): string => `data:image/svg+xml;utf8,${encodeURIComponent(BASE_SVG.replace('__FILL__', fill))}`;

export const JOBSITE_ICON_DEFAULT = tint('#2ECC40'); // green — fresh or no data
export const JOBSITE_ICON_YELLOW = tint('#F1C40F'); // 7-21 days
export const JOBSITE_ICON_RED = tint('#E63946'); //  22+ days

// Buckets must match the map summary table in GroupSummaryMap.tsx:
// green < 7 days, yellow 7-21 days, red 22+ days.
export const iconForMaxDaysOnsite = (maxDaysOnsite: number | null | undefined): string => {
  if (maxDaysOnsite == null) return JOBSITE_ICON_DEFAULT;
  if (maxDaysOnsite > 21) return JOBSITE_ICON_RED;
  if (maxDaysOnsite >= 7) return JOBSITE_ICON_YELLOW;
  return JOBSITE_ICON_DEFAULT;
};

// Remediation map pin color by pickup readiness (matches the pipeline board):
// not ready (flag not set) = red, ready (flagged, no pickup date) = yellow,
// scheduled (flagged, has a pickup date) = green.
export type PickupStatus = 'not_ready' | 'ready' | 'scheduled';

export const iconForPickupStatus = (status: PickupStatus | null | undefined): string => {
  if (status === 'ready') return JOBSITE_ICON_YELLOW;
  if (status === 'scheduled') return JOBSITE_ICON_DEFAULT; // green
  return JOBSITE_ICON_RED; // not_ready (or unknown)
};
